<template lang="pug">
  div
    top-nav(headerColor="white")
    exhibitions-past(v-if="param === 'past'")
    exhibitions-traveling(v-else-if="param === 'traveling'")
    exhibitions-upcoming(v-else-if="param === 'upcoming'")
    exhibitions-year(v-else)
    bottom-nav(footerColor="white")
</template>

<script>
import ComponentMixin from '@/mixins/ComponentMixin'
import ExhibitionsYear from '@/components/ExhibitionsYear'
import ExhibitionsPast from '@/components/ExhibitionsPast'
import ExhibitionsTraveling from '@/components/ExhibitionsTraveling'
import ExhibitionsUpcoming from '@/components/ExhibitionsUpcoming'

export default {
  name: 'exhibitions-overview',
  mixins: [ComponentMixin],
  components: {
    ExhibitionsPast,
    ExhibitionsYear,
    ExhibitionsTraveling,
    ExhibitionsUpcoming
  },

  computed: {
    param: function () {
      return this.$route.params.year
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
</style>



// WEBPACK FOOTER //
// ExhibitionsOverview.vue?cac48104